import { ofType } from "redux-observable";
import { get, omit } from "lodash-es";
import { from, of } from "rxjs";
import { mergeMap, map, catchError } from "rxjs/operators";
import { ajax, AjaxError } from "rxjs/ajax";
import { SEND_OTP, VERIFY_OTP } from "./type";
import { SEND_OTP_API, VALIDATE_OTP_API } from "../../constants/routes";
import { queryParam } from "../../utils/functions";

export const SendOTPEpic = (action$: any) =>
  action$.pipe(
    ofType(SEND_OTP.name),
    mergeMap((action) =>
      from(
        ajax({
          url: SEND_OTP_API + queryParam(get(action, "payload", {})),
          method: "GET",
          async: false,
          headers: {
            "Content-Type": "application/json",
          },
        })
      ).pipe(
        map((response) => SEND_OTP.successAction(response, action)),
        catchError((error: AjaxError) =>
          of(SEND_OTP.failureAction(error, action))
        )
      )
    )
  );

export const VerifyOtpEpic = (action$: any) =>
  action$.pipe(
    ofType(VERIFY_OTP.name),
    mergeMap((action) =>
      from(
        ajax({
          url: VALIDATE_OTP_API,
          // + queryParam(get(action, 'payload', {})),
          method: "POST",
          // async: false,
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(get(action, "payload", {})),
        })
      ).pipe(
        map((response) => VERIFY_OTP.successAction(response, action)),
        catchError((error: AjaxError) =>
          of(VERIFY_OTP.failureAction(error, action))
        )
      )
    )
  );
